<template>
  <div>

  <v-toolbar class="pink">
    <v-toolbar-side-icon @click.native.stop="sidebar = !sidebar" />
    <v-toolbar-title>{{store.title}}</v-toolbar-title>
    <v-btn icon>
      <v-icon>search</v-icon>
    </v-btn>
    <v-menu bottom left origin="top right">
      <v-btn icon="icon" slot="activator" class="white--text">
        <v-icon>more_vert</v-icon>
      </v-btn>
      <v-list>
        <v-list-item>
          <v-list-tile @click.native.stop="">
            <v-list-tile-title class="more_vert item">Your Jobs</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
        <v-list-item>
          <v-list-tile @click.native.stop="logOut()">
            <v-list-tile-title class="more_vert item">Logout</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
        <!-- <v-list-item>
          <v-list-tile router v-bind:href="{name: 'Login'}">
            <v-list-tile-title class="more_vert item">Login</v-list-tile-title>
          </v-list-tile>
        </v-list-item> -->
      </v-list>
    </v-menu>


  </v-toolbar>

  <v-sidebar v-model="sidebar" drawer>
    <v-card>
      <v-card-row height="10rem" class="cyan">
        <v-card-text>
          <v-card-title>
            <v-btn icon dark @click.native.stop="sidebar = !sidebar">
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <!-- <div class="title white--text pl-5">{{store.user.data.name}}</div> -->
          </v-card-title>
        </v-card-text>
      </v-card-row>
    </v-card>
    <v-list>
      <v-list-item v-for="item in lists" v-bind:key="item.title">
        <v-list-tile avatar router v-bind:href="item.route">
          <v-list-tile-avatar>
            <v-icon v-bind:class="[item.iconClass]">{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title v-text="item.title" />
        </v-list-tile>
      </v-list-item>
      <v-divider light></v-divider>
      <!-- <v-list-item v-for="item in people" v-bind:key="item.title">
        <v-list-tile avatar router v-bind:href="item.route">
          <v-list-tile-avatar>
            <v-icon v-bind:class="[item.iconClass]">{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title v-text="item.title" />
        </v-list-tile>
      </v-list-item> -->
    </v-list>
  </v-sidebar>

</div>

</template>

<script>
// Firebase
import firebase from '../modules/firebase'
// Store
import store from '../modules/store'

export default {
  components: {
    // 'sidebar': Sidebar
  },
  methods: {
    logOut: function () {
      firebase.auth().signOut()
      this.$router.push({name: 'Login'})
    }
  },
  data () {
    return {
      store,
      sidebar: false,
      menu: [
        {}
      ],
      lists: [
        {title: 'In regola', route: {name: 'Main', query: {status: 'active'}}, icon: 'label'},
        {title: 'Accettati', route: {name: 'Main', query: {status: 'accepted'}}, icon: 'label'},
        {title: 'Richieste', route: {name: 'Main', query: {status: 'submitted'}}, icon: 'label'},
        {title: 'Incompleti', route: {name: 'Main', query: {status: 'incomplete'}}, icon: 'label'},
        {title: 'Inattivi', route: {name: 'Main', query: {status: 'inactive'}}, icon: 'label'},
        {title: 'Tutti', route: {name: 'Main'}, icon: 'label'}

        // {title: 'In progress', route: {name: 'Weddings', query: {entry: 'inprogress'}}, icon: 'label'},
        // {title: 'Completed', route: {name: 'Weddings', query: {entry: 'completed'}}, icon: 'label'},
        // {title: 'Archive', route: {name: 'Weddings', query: {entry: 'archive'}}, icon: 'label'}
      ],
      people: [
        {title: 'Francesco Rao', icon: 'label'},
        {title: 'Dario Michelino', icon: 'label'}
      ],
      messages: [
        {title: 'Messages', icon: 'label'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Toolbar.vue?9134710c